module.exports = __webpack_public_path__ + "img/1719.182e4d67.jpg";